import { claimFreePackage } from "@/API/offers";

export const chainClaim = {
  methods: {
    // Claim a free (zero-price) package: claim → play the full reward-earned
    // animation (same as other reward grants) → refetch the chain so the claimed
    // tile flips to `collected` and the next package becomes `current` in place.
    async claimPackage(payPackage) {
      if (this.claiming) return;
      this.claiming = true;
      try {
        const offerId = (this.offerData && this.offerData.id) || null;
        const claimResult = await claimFreePackage(payPackage.id, offerId);

        // Full-screen reward animation overlays the open modal. Wait for it to
        // finish BEFORE refetching the chain — the refetch updates the layout
        // data, which triggers the scroll-to-current transition. Sequencing
        // them stops the tiles from sliding while the reward is still playing.
        await this.playClaimRewardAnimation(claimResult, payPackage);

        this.$store.commit("shop/setOfferChainUnlockAnim", true);

        const active = await this.$store.dispatch("shop/fetchOfferChain");
        const id = this.offerData && this.offerData.id;
        const stillActive =
          Array.isArray(active) && active.some((c) => c && c.id === id);
        if (stillActive) {
          this.$store.commit("shop/setShowOfferChainModal", true);
        } else {
          // Last package collected → chain complete. Close the modal; the stale
          // selection is cleared on @hidden (after the hide transition) to avoid
          // tearing the open modal out of the DOM mid-transition.
          this.$store.commit("shop/setOfferChainUnlockAnim", false);
          this.closeModal();
        }
        this.$store.dispatch("user/updateUser");
      } catch (error) {
        console.error("[OfferChain] claim failed:", this.claimErrorInfo(error));
        this.displayClaimError(error);
      } finally {
        this.claiming = false;
      }
    },
  },
};
